export const PITTS = 'University of Pittsburgh'
export const FP = 'Florida Poly'
export const GGU = 'Golden Gate University'
